import clsx from 'clsx';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { IoWarningOutline } from 'react-icons/io5';
import { MdErrorOutline } from 'react-icons/md';
import { IIconLabel } from './types';

export type Type = 'info' | 'success' | 'warning' | 'error';

const Icon: Record<Type, React.ReactNode> = {
  info: <AiOutlineInfoCircle size={16} className="mt-[3px] fill-info" />,
  warning: <IoWarningOutline size={16} className="mt-[3px] fill-warning" />,
  error: <MdErrorOutline size={16} className="mt-[3px] fill-error" />,
  success: <AiOutlineInfoCircle size={16} className="mt-[3px] fill-success" />,
};

export function IconLabel({ type, title, rootClassName }: IIconLabel) {
  return (
    <div className={clsx(`flex flex-row space-x-2 text-base text-${type}`, rootClassName)}>
      <div className="h-4 w-4">{Icon[type as keyof typeof Icon]}</div>
      {typeof title === 'string' ? <p>{title}</p> : title}
    </div>
  );
}
